import { all } from 'redux-saga/effects';
import contactInfoServiceWorker from './contactInfoSaga';
import getContactInfoServiceWorker from './contactInfoSaga';

export default function* rootSaga(action) {
	yield all([contactInfoServiceWorker(action)]);
	yield all([getContactInfoServiceWorker(action)]);
}
